import { Plugin } from 'prosemirror-state';

function stripCustomTags(text) {
  // Remove [fontSize=...]...[/fontSize], [fontFamily=...]...[/fontFamily], [textColor=...]...[/textColor]
  return text
    .replace(/\[fontSize=[^\]]+\]([^[]*)\[\/fontSize\]/gi, '$1')
    .replace(/\[fontFamily=[^\]]+\]([^[]*)\[\/fontFamily\]/gi, '$1')
    .replace(/\[textColor=[^\]]+\]([^[]*)\[\/textColor\]/gi, '$1');
}

export const plainPastePlugin = new Plugin({
  props: {
    handlePaste(view, event, slice) {
      // Only handle plain text paste
      if (event.clipboardData) {
        let text = event.clipboardData.getData('text/plain');
        if (text) {
          text = stripCustomTags(text);
          view.dispatch(
            view.state.tr.insertText(
              text,
              view.state.selection.from,
              view.state.selection.to
            )
          );
          return true; // Prevent default paste
        }
      }
      return false;
    },
  },
});
